// React Dependencies
import React, { useEffect, useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';

// Internal Dependencies
import apiService from '../../services.js/apiService';
import { IsEmpty } from '../../common/checks';
import ContriPoiHeader from './header';
import ContriPoiInfo from './contriPoiInfo';

const ContriPoiDetails = (props) => {
  const contriPoiId = props.match.params.id;
  const [contriPoi, setContriPoi] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchContriPoi = async () => {
    try {
      setLoading(true);
      const data = await apiService.getContriPOIById(contriPoiId);
      if (IsEmpty(data)) {
        toast.error('Contribution POI not found');
        return;
      }
      setContriPoi(data);
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchContriPoi();
  }, [contriPoiId]);

  if (IsEmpty(contriPoi) || loading) {
    return <></>;
  }

  return (
    <div className="container-fluid px-0">
      <div className="row">
        <div className="col-12">
          <ContriPoiHeader contriPoi={contriPoi} />
        </div>
      </div>
      <div className="row">
        <ContriPoiInfo contriPoi={contriPoi} onRefresh={fetchContriPoi} />
      </div>
    </div>
  );
};

ContriPoiDetails.propTypes = {
  match: PropTypes.shape(Object).isRequired,
};

export default ContriPoiDetails;
